module.exports = __webpack_public_path__ + "img/avatar-upload-icon.e927bae0.svg";